import { useMutation } from 'react-query';
import {
  generateConsumablesReport,
  generateGroupsReport,
  generateInventoryReport,
  generateManufacturersReport,
  generateMinimumStockReport,
  generatePartsReport,
  generatePlanAccountReport,
} from './Report.service';
import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';

export function useGenerateManufacturersReport() {
  return useMutation(generateManufacturersReport, {
    onError(error) {
      useServiceError(error);
    },
  });
}

export function useGeneratePartsReport() {
  return useMutation(generatePartsReport, {
    onError(error) {
      useServiceError(error);
    },
  });
}

export function useGenerateGroupsReport() {
  return useMutation(generateGroupsReport, {
    onError(error) {
      useServiceError(error);
    },
  });
}

export function useGeneratePlanAccountsReport() {
  const intl = useIntl();

  return useMutation(generatePlanAccountReport, {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'planAccounts.notification.generate.report.title',
        }),
        description: intl.formatMessage({
          id: 'planAccounts.notification.generate.report.description',
        }),
      });
    },
  });
}

export function useGenerateConsumablesReport() {
  return useMutation(generateConsumablesReport, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso!',
        description: 'Relatório de insumos gerado com sucesso!',
      });
    },

    onError(error) {
      useServiceError(error);
    },
  });
}

export function useGenerateMinimumStockReport() {
  return useMutation(generateMinimumStockReport, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso!',
        description: 'Relatório de estoque mínimo gerado com sucesso!',
      });
    },

    onError(error) {
      useServiceError(error);
    },
  });
}

export function useGenerateInventoryReport() {
  return useMutation(generateInventoryReport, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso!',
        description: 'Relatório de inventário gerado com sucesso!',
      });
    },

    onError(error) {
      useServiceError(error);
    },
  });
}
